import { message } from "antd";
import _NewapplicationService from "../modules/NewapplicationService";
import { routes } from "../routes/Routes";
import { SESSION_TOKEN, COMMON_ERROR_MSG } from "../constants/constants";

// Applies an already-fetched Applicant/UserLogin response (Obj) as a Firm Admin session and lands on
// the Firm Admin Dashboard. Shared by every entry point that redirects a Subscription Line of Credit/
// Corporate Loan Firm Admin (Is_Subscription_Corporate_FirmAdminUser) there: registration (via
// redirectToFirmAdminDashboard below, which fetches the response itself) and the plain Client Portal
// login (which already has the response from its own login call and shouldn't log in twice).
export function applyFirmAdminSession(obj, email, password, history) {
    localStorage.setItem(SESSION_TOKEN, obj?.AuthToken);
    // Not obj?.Role: UserLogin forces Role back to "Applicant" whenever the request itself was sent
    // with IsFirmAdmin:false (e.g. the plain Client Portal login, which doesn't know in advance this
    // is a Firm Admin -- that's exactly what Is_Subscription_Corporate_FirmAdminUser is auto-detecting).
    // Every caller of this function is already committed to landing on the Firm Admin Dashboard, so the
    // role is set explicitly here instead of trusting a value the backend may have just overridden.
    localStorage.setItem("userRole", "FirmAdmin");
    localStorage.setItem("IsFirmAdminFlag", obj?.IsFirmAdmin);
    localStorage.setItem("HasOtherRoleAssociation", obj?.HasOtherRoleAssociation);
    localStorage.setItem("SponserIdForFirmLogin", obj?.SponserId);
    localStorage.setItem("Id", obj?.Id);
    localStorage.setItem("ApplicationId", obj?.Id);
    localStorage.setItem("BankAdminId", obj?.BankAdminId);
    localStorage.setItem("BankerId", obj?.BankerId);
    localStorage.setItem("ApplicationEmailId", obj?.Email);
    localStorage.setItem("loginEmail", email);
    localStorage.setItem("IsKey", password);
    localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(true));
    history.push({ pathname: routes.firmadmindashboard.path, state: { email } });
}

// Logs a Firm Administrator straight into the Firm Admin Dashboard right after OTP confirmation or
// password set-up, for the Subscription Line of Credit/Corporate Loan flow (Is_Subscription_
// Corporate_FirmAdminUser). Mirrors FirmAdminLogin.js's own login handler exactly, since this is the
// same underlying Applicant/UserLogin + IsFirmAdmin flow, just reached from registration instead of a
// manual login form.
export async function redirectToFirmAdminDashboard(email, password, history) {
    try {
        const res = await _NewapplicationService.userLogin({ Email: email, Password: password, IsFirmAdmin: true });
        if (res.data.IsSuccess) {
            applyFirmAdminSession(res.data.Obj, email, password, history);
        } else {
            message.error(res.data.Message || COMMON_ERROR_MSG);
            history.push(routes.firmadminlogin.path);
        }
    } catch (err) {
        console.log(err);
        message.error(COMMON_ERROR_MSG);
        history.push(routes.firmadminlogin.path);
    }
}
